import { Avatar } from '@mantine/core'
import { useUserData } from './api'

function getInitials(firstName: string, lastName: string): string {
  const first = firstName?.charAt(0)?.toUpperCase() || ''
  const last = lastName?.charAt(0)?.toUpperCase() || ''
  return `${first}${last}` || ''
}

export default function AvatarMe({
  size,
  className,
}: {
  size: 'sm' | 'md' | 'lg'
  className?: string
}) {
  const { data: user } = useUserData(location.pathname)
  return (
    <Avatar
      size={size}
      className={className}
      color="white"
      src={user.photo_url}
    >
      {getInitials(user.first_name, user.last_name)}
    </Avatar>
  )
}
